import { createSelector } from 'reselect';

import options from './options';

const { name } = options;

export const curLeafPoints = state => state.models[name].fieldPoints;
export const curLeafResults = state => state.models[name].calculationResults;